export function outcomeDescriptions() {
  return {
    "Carbon Emissions": {
      Explanation: {
        title: "What are Carbon Emissions?",
        html: `Carbon dioxide emissions or CO2 emissions are emissions stemming from human activities which strengthen the greenhouse effect, causing climate change.<br />
        <br />
        Most emissions are from burning fossil fuels: coal, oil, and natural gas. Human-caused emissions have increased atmospheric carbon dioxide by about 50% above pre-industrial levels.`,
      },
      Goal: {
        title: "What are you trying to achieve in your Carbon Emissions Plan?",
        html: `By creating a Carbon Emissions Plan you can show your commitment to reducing your carbon footprint and create a strategy to become carbon neutral.<br />
        <br />
        The 2030 Paris Agreement aims to keep the global average temperature well below 2*C, ideally 1.5*C, compared to pre industrial levels. <br />
        <br />
        Many countries want to have net zero emissions by 2050.
        `,
      },
      Examples: {
        title: "What are some examples that create Carbon Emissions?",
        html: `Examples of carbon emitting activities include;<br />
        <br />
        <ul>
          <li>
            Electricity production and usage
          </li>
          <li>
            Diesel and Petrol Transportation
          </li>
          <li>
            Deforestation
          </li>
          <li>
            Commercial refrigerant top-ups
          </li>
          <li>
            Waste going to landfill
          </li>
          <li>
            Factories running coal boilers
          </li>
          <li>
            Methane emissions from agriculture
          </li>
        </ul>`,
      },
    },
    "Energy Management": {
      Explanation: {
        title: "What are renewable and non-renewable energy sources?",
        html: `Some examples of renewable sources that produce electricity are hydro, geothermal, wind and bioenergy. These elements are harnessed to produce electricity.<br />
        <br />
        Non-renewable energy sources, also known as ‘dirty’ fossil fuels, include coal, gas, diesel, petrol and oil. These sources are only available in limited amounts and take a long time to replenish. `,
      },
      Goal: {
        title: "What are you trying to achieve with a Energy Management Plan?",
        html: `There are two parts to a good Energy Management Plan: <br />
        <br />
        <ul>
          <li>
            The first part enables you to have a plan of how to minimise the use of non-renewable energy sources and increase the use of renewable sources of energy.
          </li>
          <li>
            The second part shows how you will maximise energy efficiencies eg: improving heat loss, saves income and lower carbon emissions
          </li>
        </ul>`,
      },
      Examples: {
        title: "What are some examples of good energy management?",
        html: `Examples of non-renewable energy sources include;<br />
        <br />
        <ul>
          <li>
            Coal
          </li>
          <li>
            Diesel
          </li>
          <li>
            Petrol
          </li>
          <li>
            Oil
          </li>
          <li>
            Electricity
          </li>
        </ul>
        <br />
        Examples of renewable energy sources include; <br />
        <br />
        <ul>
          <li>
            Biofuel
          </li>
          <li>
            Biomass
          </li>
          <li>
            Solar
          </li>
          <li>
            Wind
          </li>
          <li>
            Hydro
          </li>
        </ul>
        `,
      },
    },
    "Waste Management": {
      Explanation: {
        title: "What is Waste?",
        html: `There are a variety of ways that you can define waste; waste is unwanted or unusable materials, any substance which is discarded after primary use, or is worthless, defective and of no use.<br />
        <br />
        Waste can be classified into five different types; Solid rubbish, liquid waste, organic waste, recyclable rubbish and hazardous waste.`,
      },
      Goal: {
        title: "What are you trying to achieve with a Waste Management Plan?",
        html: `A good Waste Management Plan will highlight the current waste streams and will set goals to reduce or improve the diversion of these. Many waste streams can be diverted from landfill.<br />
        <br />
        The 5 R's of Waste: Reject, Reduce, Repurpose, Recycle & Rot. You can add these into your plan to show how you are diverting your waste from landfill.`,
      },
      Examples: {
        title: "What are some examples of common waste streams?",
        html: `Examples of waste streams include;<br />
        <br />
        <ul>
          <li>
            Cardboard & Paper
          </li>
          <li>
            E-Waste
          </li>
          <li>
            Office Waste
          </li>
          <li>
            Site Waste
          </li>
          <li>
            Organics & Food Scraps
          </li>
          <li>
            Plastics
          </li>
          <li>
            Tyres
          </li>
        </ul>
        `,
      },
    },
    Water: {
      Explanation: {
        title: "Why we should use Water wisely ?",
        html: `Water is vital for all known forms of life, our ecosystems depend on it. It is also the lifeblood of our economy; we rely on it for all sorts of industries including manufacturing of food and goods, energy production and for transport of imports and exports throughout the world.<br />
        <br />
        Only 0.3% of water on the earth is usable by humans. We need to use this resource wisely and conserve where possible.`,
      },
      Goal: {
        title: "What are you trying to achieve with a Water Management Plan?",
        html: `A good Water Management Plan will highlight the ways in which you currently use water and how you can be more responsible with your water consumption through techniques such as;<br />
        <br />
        <ul>
          <li>
            Reduction of Water Waste
          </li>
          <li>
            Water Capture to Repurpose & Re-use
          </li>
        </ul>
        `,
      },
      Examples: {
        title: "What are some examples of water management solutions?",
        html: `Examples of water management solutions include;<br />
        <br />
        <ul>
          <li>
            Install gray water systems
          </li>
          <li>
            Install subsurface drip irrigation in gardens
          </li>
          <li>
            Mulch landscaping to conserve water
          </li>
          <li>
            Set appliances to use minimal water
          </li>
          <li>
            Use water-recycling car washes for your fleet
          </li>
          <li>
            Mop floors with half-filled buckets
          </li>
          <li>
            Install water capture equipment to collect rainwater
          </li>
        </ul>`,
      },
    },
    "Use Local": {
      Explanation: {
        title: "What does “Use Local” mean?",
        html: `The heart of using local suppliers is to support those in our own backyard and retain profits in the region.<br />
        <br />
        Research suggests that up to 76 cents out of every dollar spent with a local supplier stays within that same area. There is the added benefit of lower transport costs and “scope 3” carbon emissions by using local suppliers.`,
      },
      Goal: {
        title: "What are you trying to achieve with a Local Impact Plan?",
        html: `A good Local Impact plan will highlight local suppliers you are using, identify ways to increase use and report on the impact being created.<br />
        <br />
        Ultimately you will be able to;<br />
        <br />
        <ul>
          <li>
            Calculate your impact on the local economy
          </li>
          <li>
            Find stories of how local suppliers are creating outcomes you want to achieve
          </li>
          <li>
            Gain a better insight as to how using local suppliers impacts your sustainability goals
          </li>
        </ul>
        `,
      },
      Examples: {
        title: "What are some solutions to use local suppliers?",
        html: `Examples of supporting local suppliers include;<br />
        <br />
        <ul>
          <li>
            Give shelf space to emerging local suppliers
          </li>
          <li>
            Source local gifts for employees and clients
          </li>
          <li>
            Adopt a local shop
          </li>
          <li>
            Use local industry associations to find suppliers
          </li>
        </ul>`,
      },
    },
    "Use SME's": {
      Explanation: {
        title: "What is an “SME”?",
        html: `SMEs (Small and Medium Enterprises) play an important role and are often the lifeblood of an economy and community.<br />
        <br />
        Countries define small and medium enterprises differently, but consistently research suggests SMEs make up 99% of a country's economy.<br />
        <br />
        In NZ we define a small enterprise as having 1-19 full time equivalent employees. Medium enterprises as 20-49 full time equivalent employees.`,
      },
      Goal: {
        title: "What are you trying to achieve in your Supporting SMEs Plan?",
        html: `A good Supporting SMEs plan will highlight how many small and medium enterprises you are using in your supply chain.<br />
        <br />
        It will also allow you to set goals, find solutions and report on the outcomes you are trying to achieve in relation to SMEs.<br />
        <br />
        SMEs make an enormous contribution to inclusive and sustainable growth and their value to the economy should not be underestimated.`,
      },
      Examples: {
        title: "What does supporting SMEs look like?",
        html: `Examples of supporting SMEs could include;<br />
        <br />
        <ul>
          <li>
            Use SME restaurants for staff functions
          </li>
          <li>
            Buy corporate gifts from SMEs
          </li>
          <li>
            Get to know local SMEs personally
          </li>
          <li>
            Like SMEs on social media
          </li>
        </ul>`,
      },
    },
    "Social Procurement": {
      Explanation: {
        title: "What is Social Procurement?",
        html: `Social Procurement happens when you use an organisation in your supply chain that creates a social, cultural or sustainable outcome.<br />
        <br />
        These organisation can often be defined as Social Enterprises (or Impact Enterprises). When you use them you are creating impact while getting the products and services that you need. `,
      },
      Goal: {
        title: "What are you trying to achieve with a Social Procurement Plan?",
        html: `Your Social Procurement Plan highlights the current impact you are achieving in your supply chain, identifies opportunities that could be relevant and reports the impact you create when you use impact enterprises.<br />
        <br />
        Many organisation don't realise how practical and easy it is to create social procurement outcomes. Your plan will highlight areas and ways to do this.`,
      },
      Examples: {
        title: "What are some examples of Social Procurement?",
        html: `Examples of Social Procurement include;<br />
        <br />
        <ul>
          <li>
            You may use cleaning products packed by adults with disabilities
          </li>
          <li>
            You decided to use a waste company that diverts your waste from landfill
          </li>
          <li>
            You support a cafe that is passionate about creating sustainable and social outcomes
          </li>
          <li>
            Your company uniforms are from an ethical clothing store
          </li>
        </ul>`,
      },
    },
    Charitable: {
      Explanation: {
        title: "What does Charitable mean?",
        html: `A not-for-profit organisation exists to support a social cause, activity, or community development. Rather than the profits going to shareholders, the money is directed to help fund the organisation’s objectives and goals as well as cover operational costs to ensure the organisation is viable. Not-for-profits are often run by a combination of paid staff and volunteers.`,
      },
      Goal: {
        title: "What are you trying to achieve with a Charitable Impact Plan?",
        html: `A Charitable Impact Plan highlights your heartbeat and passion to support your community.<br />
        <br />
        Many Charitable organisations are performing amazing and essential services in our communities.Your plan identifies how you can have greater impact and synergy with them.
        <br />
        <br />
        Discover how you are currently supporting the community, find ways to broaden your impact and showcase these stories.`,
      },
      Examples: {
        title: "Examples of supporting Charitable organisations?",
        html: `Examples of supporting a Charitable organisation could include;<br />
        <br />
        <ul>
          <li>
            Donate a set percent of profits to charity
          </li>
          <li>
            Do pro bono work for a charity
          </li>
          <li>
            Donate surplus assets to charity
          </li>
          <li>
            Donate unsaleable grocery products to charity
          </li>
        </ul>`,
      },
    },
    "Health & Wellbeing": {
      Explanation: {
        title: "What is Health & Wellbeing?",
        html: `Employees health and wellbeing is a key factor in determining an organisation's long-term effectiveness. Many studies show a direct link between productivity levels and the general Health & Wellbeing of employees.<br />
        <br />
        Health & Wellbeing relates to all aspects of working life, from the quality and safety of the physical environment, to how workers feel about their work and their working environment.`,
      },
      Goal: {
        title: "What are you trying to achieve with a Health & Wellbeing Plan?",
        html: `A Health & Wellbeing Plan will highlight how your organisation will promote wellbeing and a mentally healthy culture and climate and will demonstrate its commitment to its people.<br />
        <br />
        It will also allow you to set goals, find solutions and ideas to achieve them and tell stories around how you've improved the Health & Wellbeing of your employees.`,
      },
      Examples: {
        title: "Examples of valuing Health & Wellbeing in your organisation?",
        html: `Examples of Health & Wellbeing in your organisation include;<br />
        <br />
        <ul>
          <li>
            Allow mental health days for sick leave
          </li>
          <li>
            Use signage to promote work-life balance
          </li>
          <li>
            Let staff choose ergonomic furniture and tech
          </li>
          <li>
            Create a health & wellbeing policy
          </li>
          <li>
            Offer employees reduced-rate gym memberships
          </li>
          <li>
            Take regular staff wellness and satisfaction surveys
          </li>
          <li>
            Organise a staff retreat at an exciting destination
          </li>
          <li>
            Share employee success stories in staff communications
          </li>
          <li>
            Allow flexible work schedules
          </li>
        </ul>`,
      },
    },
    "Training & Dev": {
      Explanation: {
        title: "What is Training & Development?",
        html: `Training and Development involves improving the effectiveness of organisations and the individuals and teams within them.<br />
        <br />
        Training is a common form of employee development; other forms include coaching, mentoring, informal learning, self-directed or experiential learning. Development is the acquisition of knowledge, skill, or attitude that prepares people for new directions or responsibilities.`,
      },
      Goal: {
        title:
          "What are you trying to achieve with your Training & Development Plan?",
        html: `A Training and Development Plan highlights how you as an organisation are prioritising the development of your staff.<br />
        <br />
        Having a plan will help you retain top talent as well as boost staff morale and increase staff productivity.`,
      },
      Examples: {
        title: "Examples of Training & Development in your organisation?",
        html: `Examples of Training & Development in your organisation include;<br />
        <br />
        <ul>
          <li>
            Invest in employees for the long term
          </li>
          <li>
            Bring in external specialists for specific topics
          </li>
          <li>
            Recognise staff who initiate workplace improvements
          </li>
        </ul>`,
      },
    },
    "Diversity, Equity & Inclusion": {
      Explanation: {
        title: "What is Diversity, Equity & Inclusion?",
        html: `Diversity, Equity, and Inclusion is often shortened to DEI.<br />
        <br />
        DEI is a term used to describe policies and programs that promote the representation and participation of different groups of individuals, including people of different ages, races and ethnicities, abilities and disabilities, genders, religions, cultures and sexual orientations in your organisation.`,
      },
      Goal: {
        title: "What are you trying to achieve with your DEI Plan?",
        html: `Advancing your diversity, equity, and inclusion (DEI) efforts requires shifting behaviors toward more equitable and inclusive leadership.<br />
        <br />
        Your DEI plan will highlight the areas in which your organisation needs to improve and showcase how you will achieve this.<br />
        <br />
        We are all on a journey and your plan will help you celebrate the improvement of DEI in your organisation.`,
      },
      Examples: {
        title: "What are some solutions to improve DEI in your organisation?",
        html: `Examples of DEI solutions include;<br />
        <br />
        <ul>
          <li>
            Use a roundtable meeting format
          </li>
          <li>
            Pay employees a living wage
          </li>
          <li>
            Partner with nonprofits that mentor disadvantaged applicants
          </li>
          <li>
            Give introverts time to think before commenting
          </li>
          <li>
            Eliminate hiring decisions based on culture fit
          </li>
        </ul>`,
      },
    },
    "Sustainability Innovation": {
      Explanation: {
        title: "What does Innovation mean in terms of Sustainability?",
        html: `That you look for innovative ways to achieve your sustainability goals. An organisation that values sustainability innovation will develop ground-breaking ideas, tools, products, services or marketing methods that promote and achieve the organisation's sustainability goals.<br />
        <br />
        A focus on sustainable innovation often leads to new income streams, profitable cross-industry collaboration, and increased employee satisfaction. `,
      },
      Goal: {
        title:
          "What are you trying to achieve with a Sustainability Innovation Plan?",
        html: `Your Sustainability Innovation Plan lets you highlight innovative methods you have adopted already and plan to implement in your organisation that will improve sustainability.<br />
        <br />
        Your plan will highlight the areas in which your organisation needs to improve and showcase how you will achieve this.`,
      },
      Examples: {
        title: "Examples of Sustainability Innovation?",
        html: `Examples of Sustainability Innovation include:<br />
        <br />
        <ul>
          <li>
            Giving employees work time to pursue self-directed innovation projects
          </li>
          <li>
            Creating cross-functional teams to support innovation projects
          </li>
          <li>
            Implementing systems to monitor the progress of innovation projects
          </li>
          <li>
            Providing innovation training for staff
          </li>
          <li>
            Increasing your Innovation budget to achieve your sustainability goals
          </li>
        </ul>`,
      },
    },
    "Sustainability Leadership": {
      Explanation: {
        title: "What does Leadership mean in terms of Sustainability?",
        html: `That your governance and leadership teams are on the same page around your sustainability goals. Sustainability Leadership involves developing management structures, organisation policies, accountability systems and external collaborations that promote economic, social and environmental sustainability.<br />
        <br />
        Additional aspects include setting sustainability goals, responding rapidly to changes in sustainability regulations and actively rewarding employees' sustainability successes.`,
      },
      Goal: {
        title:
          "What are you trying to achieve with a Sustainability Leadership Plan?",
        html: `If your leadership, governance and management are not on the same page around your sustainability goals, then your success is going to be hindered. This plan will enable you to focus on critical goals and solutions to ensure that your organisation is headed and empowered in the right direction.<br />
        <br />
        Your Sustainability Leadership plan will highlight the areas in which your organisation needs to improve and showcase how you will achieve this.`,
      },
      Examples: {
        title: "Examples of Sustainability Leadership solutions?",
        html: `Sustainability Leadership may include:<br />
        <br />
        <ul>
          <li>
            Designating sustainability leaders and giving them authority
          </li>
          <li>
            Ensuring the organisation meets sustainability regulations
          </li>
          <li>
            Developing ways to motivate staff around sustainability
          </li>
          <li>
            Setting up sustainability audit systems
          </li>
          <li>
            Choosing areas of sustainability to focus on for greatest impact
          </li>
          <li>
            Creating clear, achievable sustainability goals.
          </li>
        </ul>`,
      },
    },
  };
}
